import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AIVoice } from 'js/src/client';
import PlainJsStoreORM from 'js/src/data/plain-js-store-orm';

const getInitialState = () => PlainJsStoreORM.createEmpty<AIVoice, string>().data;

export const aiVoicesSlice = createSlice({
    name: 'aiVoices',
    initialState: getInitialState(),
    reducers: {
        setAIVoices: (state, action: PayloadAction<AIVoice[]>) => {
            const orm = new PlainJsStoreORM(state);
            action.payload.forEach((voice) => {
                orm.pushItem(voice, 'slug');
            });
            return orm.data;
        },
    },
});

export const { setAIVoices } = aiVoicesSlice.actions;
